import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-user-management-link',
  imports: [MatIconModule, MatButtonModule, RouterModule, TranslateModule],
  template: `
    <a mat-stroked-button color="primary" [routerLink]="['/', 'users']">
      <mat-icon svgIcon="user" />
      {{ 'admin.user-management.title' | translate }}
    </a>
  `,
  styleUrl: './user-management-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserManagementLinkComponent {}
